module.exports = __webpack_public_path__ + "static/023-904e618c13b07095d89a77d1985d588e.jpg";